import React from 'react';
import { ApplicationShell } from './helpers/ApplicationShell';
import { AppLayout } from './helpers/AppLayout';
import {
  APP_CONTAINER_BASE_URL,
  PROGRAM_ACCOUNTS,
  UI_CLIENTS,
  UMS_ACCOUNT_ENTITY_CLASS,
} from 'src/constants/GlobalConstants';
import {
  AuthContext,
  initialAuthContext,
} from 'src/state/providers/AuthProvider';
import {
  isAnonymousUser,
  isRegulatorCentralApp,
} from 'src/state/providers/helpers/AuthAttributeHelper';
import { useGetUserAuthorizedResourcesQuery } from 'src/state/slice/umsServiceApi';
import { KatAlert, KatSpinner } from '@amzn/katal-react';
import { emitClickMetrics, MetricsName } from 'src/metrics';
import { logger } from 'src/logger';

/**
 * Logged in CPR VICI SPIM Widget
 */
export const SPIMWidget = () => {
  const { data, isError, isLoading, error } =
    useGetUserAuthorizedResourcesQuery({
      identity: { userId: '' },
      resourceType: UMS_ACCOUNT_ENTITY_CLASS,
      isPublicPage: isAnonymousUser,
      isRegulatorCentralApp: isRegulatorCentralApp,
    });

  if (isLoading) {
    return <KatSpinner data-testid="ums-loading" />;
  }

  if (isError) {
    emitClickMetrics(MetricsName.AUTH_CONTEXT, 'INVALID');
    logger.error(
      `Unable to fetch UserDetails from UMS. Check UMS API Response error: ${JSON.stringify(
        error,
      )} and UMS Response: ${JSON.stringify(data)}`,
    );
    return (
      <KatAlert
        variant="danger"
        description="Fail to fetch user alias, please try again."
        data-testid="ums-user-alias-fetch-error"
      />
    );
  }

  return (
    <AuthContext.Provider
      value={{
        ...initialAuthContext,
        accountAttributes: [
          {
            id: PROGRAM_ACCOUNTS.SPIM,
            type: 'LENS-UMS-Account',
            attributes: {
              accountName: 'SPIM',
              domain: 'NA',
              country: 'WW',
              role: 'Program Manager',
            },
          },
        ],
        preferredAccountId: PROGRAM_ACCOUNTS.SPIM,
        clientId: UI_CLIENTS.VICI,
        customerId: data?.userId!,
        customerFullName: data?.userId!,
        emailId: `${data?.userId!}@amazon.com`,
        appContainerBaseUrl: APP_CONTAINER_BASE_URL.SPIM,
        isAnonymousUser: isAnonymousUser,
      }}
    >
      <ApplicationShell>
        <AppLayout />
      </ApplicationShell>
    </AuthContext.Provider>
  );
};
